import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import BackgroundCard from '../../../../Common/P2P/Header/BackgroundCard';
import FooterBar from '../../../../Common/P2P/Header/FooterBar';
import InvestmentForm from './InvestmentForm';
import { useDispatch, useSelector } from 'react-redux';
import { getInvestmentSummaryRequest } from '../dashboardAction';
import { useHistory } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import BorrowIconOne from '../../../../utils/assests/borrower-info.jpg';
import ReviewIconThree from '../../../../utils/assests/new-rev-3.png';
import InvestIcon from '../../../../utils/assests/investment-icon.png';

import Box from '@mui/material/Box';

function InvestmentSummaryInfo() {
  let dispatch = useDispatch();
  const history = useHistory();
  const [currentInvestment, setCurrentInvestment] = useState<any>(null);
  const [pastInvestment, setPastInvestment] = useState<any>(null);
  const [errorMessage, setErrorMessage] = useState<any>('');

  const { investmentSummary } = useSelector((state: any) => state.dashboard);

  useEffect(() => {
    dispatch(getInvestmentSummaryRequest());
  }, []);

  useEffect(() => {
    if (investmentSummary?.data?.current_investments?.length > 0) {
      const currInvestments = investmentSummary?.data?.current_investments;
      setCurrentInvestment(currInvestments.slice(0, 1));
    }
    if (investmentSummary?.data?.past_investments?.length > 0) {
      const past_investment = investmentSummary?.data?.past_investments;
      setPastInvestment(past_investment.slice(0, 1));
    } else {
      setErrorMessage(investmentSummary?.message);
    }
  }, [investmentSummary]);

  const handleKnowMore = (type: string) => {
    history.push({
      pathname: `/p2p/investmentSummary/${type}`,
    });
  };

  const handleBorrowerInfo = () => {
    history.push('/p2p/borrowerInfo');
  };

  const recentTransation = () => {
    history.push('/p2p/recentTransactions');
  };

  return (
    <>
      <Box className='pageHeadingText'>
        <Typography variant='h6'>
          Review your <strong>investments</strong> <br /> across categories
        </Typography>
      </Box>

      <BackgroundCard>
        <Card className='redBorder'>
          <CardContent>
            {' '}
            <Grid
              container
              alignItems='center'
              justifyContent='center'
              columnSpacing={2}
              className='smallCardHeading'
            >
              <Grid item>
                <img src={InvestIcon} alt='' width='100%' />
              </Grid>
              <Grid item>
                <Typography variant='h2'>
                  Investment <br /> summary
                </Typography>
              </Grid>
            </Grid>
            {currentInvestment && currentInvestment?.length > 0 ? (
              <InvestmentForm
                // title="Current Investments"
                currentInvestment={currentInvestment}
                handleKnowMore={handleKnowMore}
              />
            ) : (
              <div className='text-center text-blue fs-24 fw-400 line-normal'>
                No data found
              </div>
            )}
            {pastInvestment && pastInvestment?.length > 0 ? (
              <InvestmentForm
                // title="Past Investments"
                pastInvestment={pastInvestment}
              />
            ) : (
              ''
            )}
          </CardContent>
        </Card>{' '}
        <Grid
          container
          spacing={3}
          justifyContent='center'
          alignItems='center'
          className='threeCards'
        >
          <Grid item xs={4}>
            <Card className='redBorder' onClick={handleBorrowerInfo}>
              <CardContent>
                <img src={BorrowIconOne} alt='' />
              </CardContent>
            </Card>
            <Typography className='fs-14 fw-700 text-center text-blue'>
              Borrower <br /> information
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Card className='redBorder' onClick={recentTransation}>
              <CardContent>
                <img src={ReviewIconThree} alt='' />
              </CardContent>
            </Card>{' '}
            <Typography className='fs-14 fw-700 text-center text-blue'>
              Recent <br /> transaction
            </Typography>
          </Grid>
        </Grid>
        <FooterBar />
      </BackgroundCard>
    </>
  );
}
export default InvestmentSummaryInfo;
